window.addEventListener('DOMContentLoaded', () => {
    let tableExist = document.querySelectorAll('.table-exist')
    tableExist.forEach((item, i)=>{
        let customTables = item.querySelectorAll('custom-table-content');
        let tablesCount = item.getAttribute('data-tablescount');
        let tablesBlockInd = item.getAttribute('data-tableSectionId');
        for(let j = 0; j < tablesCount; j++){
            let ind = j+1;
            let selector = "<p>"+tablesBlockInd+"table-content"+ind+"</p>";
            let blockContent = item.innerHTML;
            blockContent = blockContent.replace(selector, '<table-content id="block-'+tablesBlockInd+'-table-'+ind+'"> </table-content>');
            item.innerHTML = blockContent;
        }
        for(let j = 0; j < tablesCount; j++){
            let ind = j+1;
            customTables.forEach((itemm)=>{
                let sel = "#block-"+tablesBlockInd+"-table-"+ind;
            })

            let indd = j+1;
            let sell = '[data-id="block-'+tablesBlockInd+'-table-'+indd+'"]'
            let uu = document.querySelector(sell)
            let insertTo = "#"+uu.getAttribute('data-id');
            document.querySelector(insertTo).append(uu);
        }
    })

})
